// src/contexts/authClient.js
// Centralize all in-memory auth state and axios instance

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

// ─── In-memory auth state (jamais localStorage) ───────────────────────────────
export const memoryAuth = {
  csrfToken: null,
  role: null,
  user: null,
  refreshTimer: null,

  set(data) {
    this.csrfToken = data.csrf_token;
    this.role = data.role;
    this.user = data.user;
  },

  clear() {
    this.csrfToken = null;
    this.role = null;
    this.user = null;
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  },

  isAuthenticated() {
    return !!this.csrfToken;
  },
};

// ─── Intercepteur CSRF partagé ────────────────────────────────────────────────
const csrfInterceptor = (config) => {
  const mutating = ['post', 'put', 'patch', 'delete'];
  if (mutating.includes(config.method) && memoryAuth.csrfToken) {
    config.headers['X-CSRF-Token'] = memoryAuth.csrfToken;
  }
  return config;
};

// ─── Instance axios pour le backend (avec credentials) ────────────────────────
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});
api.interceptors.request.use(csrfInterceptor);

// ─── Instance axios pour les API externes (SANS credentials) ──────────────────
export const externalApi = axios.create({
  // Pas de withCredentials
});

// ─── Configuration GLOBALE : Garder withCredentials pour tous les appels axios ─
// Ceci est NÉCESSAIRE pour que tous les composants existants continuent à fonctionner
axios.defaults.withCredentials = true;
axios.defaults.baseURL = API_BASE;
axios.interceptors.request.use(csrfInterceptor);

// ─── Auto-refresh ─────────────────────────────────────────────────────────────
const ACCESS_TTL_MS = (parseInt(process.env.REACT_APP_ACCESS_TTL_MIN) || 30) * 60 * 1000;
const REFRESH_BEFORE_MS = 60 * 1000;

export function scheduleTokenRefresh(onLogout) {
  const delay = ACCESS_TTL_MS - REFRESH_BEFORE_MS;
  memoryAuth.refreshTimer = setTimeout(async () => {
    try {
      const res = await api.post('/auth/refresh');
      memoryAuth.csrfToken = res.data.csrf_token;
      scheduleTokenRefresh(onLogout);
    } catch {
      memoryAuth.clear();
      if (onLogout) onLogout();
    }
  }, delay);
}

// ─── Logout ───────────────────────────────────────────────────────────────────
export async function logout(navigate) {
  try {
    await api.post('/auth/logout');
  } catch {
    // best-effort
  }
  memoryAuth.clear();
  navigate('/login', { replace: true });
}